import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cText } from "../creator/cGameObjects/cText";
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { getStr } from "../creator/utils/simpleLocalisation";


export class gameSlogan extends cDisplay {

  private sCount: number
  private leftStr: string
  private rightStr: string

  init(){
    super.init()
    console.log('INIT gameSlogan');

    var cS:cScene = this.scene as cScene;

    this.sCount = 0;
    this.leftStr = '';
    this.rightStr = '';

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{

      switch (b.command){
        case 'reset_text':
          this.leftStr = ''
          this.rightStr = ''
          this.updatetext()
          break;
        case 'eval_drop':
          console.log('EVAL',b)

          var drop:cSprite = cS.getByName( b.payload.drag )
          var tg:cSprite   = cS.getByName( b.payload.tg )

          tg.dragitem = [];
          (drop as cSprite).modules.drag.returnToOrigin()

          if (this.leftStr !== '' && this.rightStr !== '') {
            this.leftStr = ''
            this.rightStr = ''
            this.updatetext()  
          }


          if (drop.name.substring(0,4)==='left'){
            this.leftStr = drop.itemData.text
          }else{
            this.rightStr = drop.itemData.text
          }
          this.updatetext()

          if (this.leftStr !== '' && this.rightStr !== ''){
            setTimeout(()=>{
              this.sCount++
              this.updatecountdown()
              cS.triggerSceneEvent('response',{
                'response': Phaser.Math.RND.between(1,5),
                'completed': this.sCount === 5 ? 1 : 0
              })
            },10)
          }

          break;
      }
    })

  }

  updatetext(){
    var cS:cScene = this.scene as cScene;
    var drop:cText = cS.getByName('centerText')
    drop.textdata = this.leftStr + '\n' + this.rightStr
  }

  updatecountdown(){
    var str:string = getStr('countdown.from')
    str = str.replace('$1',String(this.sCount)).replace('$2',String(5));
    (this.getByName('countdown') as cText).textdata = str
  }

  buildScene(){    
    super.buildScene();
  }



}
